export default __webpack_public_path__ + "static/media/BussinessInteligence.8019a927.svg";